// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1WTmx","content":"styles_content__Y_mv-"};